// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum AuthDrawerTab {
  Login = 'login',
  Signup = 'signup',
  ForgotPassword = 'forgot-password'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const authDrawerTabComponents: Record<string, AsyncComponent> = {
  [AuthDrawerTab.Login]: () => import(/* webpackChunkName: "profile/LoginForm" */ '../LoginForm/LoginForm.vue'),
  [AuthDrawerTab.Signup]: () => import(/* webpackChunkName: "profile/SignupForm" */ '../SignupForm/SignupForm.vue')
}
